<template>
	<div>
		<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">发放比率设置</div>
		<el-row style="margin-top: 9px;">
			<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

				<el-row style="padding-left: 2%; padding-top: 40px;">

					<el-col :span="4">
						<span style="margin-left: 5px;">银行</span>
						<el-select v-model="condition.opening_bank" style="width:70%" placeholder="请选择银行" clearable>
							<el-option v-for="item in causeList" :key="item.id" :label="item.bank_name "
								:value="item.id">
							</el-option>
						</el-select>
					</el-col>

					<el-col :span="5">
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="Find">
							查询</el-button>
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="Del(null)">
							删除</el-button>
						<el-button
							style="width: 85px; background-color: #FFFFFF; color: #006E4B; border: 1px solid #006E4B;"
							@click="AddForm">
							新增</el-button>
							<!-- <el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="examine(null)">
								审批</el-button> -->
					</el-col>

				</el-row>
				<el-row style="margin: 10px 2%; margin-top: 20px;">
					<el-row style="margin-top: 10px;">
					
						<el-table :data="tableData" :header-cell-style="{background:'#d3eae2',color:'#000000'}" :span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
							style="width: 100%; margin-top: 20px" @cell-mouse-leave="cellMouseLeave"
							@cell-mouse-enter="cellMouseEnter" height="560" :cell-class-name="tableRowClassName" >
							<el-table-column type="selection" align="center" width="55">
							</el-table-column>
							<el-table-column align="center" label="序号" width="80">
								<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
							</el-table-column>
							<el-table-column prop="bank_name" align="center" label="银行"></el-table-column>
							<el-table-column prop="split_name" align="center" label="拆分账户"></el-table-column>
							<el-table-column prop="grant_proportion" align="center" label="拆分比例"></el-table-column>
							<!-- <el-table-column align="center" label="操作" width="120">
								<template slot-scope="scope">
									<img src="../../../assets/编辑.png" @click="EditForm(scope.row)">
									<img src="../../../assets/删除.png" @click="Del(scope.row.bank_id)">
								</template>
							</el-table-column> -->
						</el-table>
					</el-row>
					<!-- <el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row> -->
				</el-row>
			</div>
		</el-row>

		<el-dialog title="新增" style="text-align: center;" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<add ref="add"></add>
		</el-dialog>
		<el-dialog title="修改" style="text-align: center;" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose">
			<EditForm ref="EditForm"></EditForm>
		</el-dialog>

	</div>
</template>

<script>
	import add from "./FfblSz_add.vue";
	import EditForm from "./FfblSz_xiugai.vue";
	import axios from "axios";
	export default {
		components: {
			add: add,
			EditForm: EditForm
		},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				// 银行
				causeList: [],
				cfzhList:[],
				rowIndex: '-1',
				orderIndexArr: [],
				hoverOrderArr: [],

				//页面相关
				dialogVisible: false,
				dialogVisibles: false,

				//条件
				condition: {
					opening_bank: '',
				},

				//详情
				ruleForm: {
					id: '',
					bank_id: '',
					grantList: [{
						split_id: '',
						grant_proportion: '',
						flag: 0
					}]
				},

				//复选框ids
				ids: [],
				
			};

		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.bank_id);
				});
			},
			//删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "GrantProportion/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
				this.Find();
			},
			// 获取相同编号的数组
			getOrderNumber() {
				const orderObj = {};
				this.tableData.forEach((item, index) => {
					item.rowIndex = index;
					if (orderObj[item.bank_name]) {
						orderObj[item.bank_name].push(index);
					} else {
						orderObj[item.bank_name] = [];
						orderObj[item.bank_name].push(index);
					}
				});
				// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
				Object.keys(orderObj).forEach((key) => {
					if (orderObj[key].length > 1) {
						this.orderIndexArr.push(orderObj[key]);
					}
				});
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0 || columnIndex === 2) {
					for (let i = 0; i < this.orderIndexArr.length; i += 1) {
						let element = this.orderIndexArr[i];
						for (let j = 0; j < element.length; j += 1) {
							let item = element[j];
							if (rowIndex === item) {
					  	if (j === 0) {
									return {
					  			rowspan: element.length,
										colspan: 1,
									};
								}
								if (j !== 0) {
									return {
										rowspan: 0,
										colspan: 0,
									};
								}
							}
						}
					}
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				let arr = this.hoverOrderArr;
				for (let i = 0; i < arr.length; i += 1) {
					if (rowIndex === arr[i]) {
						return 'hovered-row';
					}
				}
			},
			cellMouseEnter(row, column, cell, event) {
				this.rowIndex = row.rowIndex;
				this.hoverOrderArr = [];
				this.orderIndexArr.forEach((element) => {
					if (element.indexOf(this.rowIndex) >= 0) {
						this.hoverOrderArr = element;
					}
				});
			},
			cellMouseLeave(row, column, cell, event) {
				this.rowIndex = '-1';
				this.hoverOrderArr = [];
			},
			//查询
			async Find() {
				var url = 'GrantProportion/selectSplit';
				var record = {
					bank_id : this.condition.opening_bank
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data;
						this.total = data.total;
						this.getOrderNumber()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.Find();
			},
			//修改页面
			EditForm(e) {
				this.dialogVisibles = true;
				this.ruleForm.id = e.id;
				this.ruleForm.bank_id = e.bank_id;
				// this.ruleForm.grantList = [
				// 	e.split_id,
				// 	e.grant_proportion
				// ]
			},
			//新增页面
			AddForm() {
				this.qingkong()
				this.dialogVisible = true;
			},
			//返回
			Return() {
				this.dialogVisible = false;
				this.Find();
				this.qingkong()
			},
			qingkong(){
				this.ruleForm.id = '';
				this.ruleForm.bank_id = '';
				this.ruleForm.split_id = '';
				this.ruleForm.grant_proportion = '';
				this.ruleForm.grantList = [];
				this.ruleForm.grantList = [{
					flag: 0,
					split_id:'',
					grant_proportion:'',
				}];
			},

		},
		async created() {
			this.Find();
			// 银行
			var causeList = await this.$globals.AxiosPost('bank/finds', {});
			this.causeList = causeList.data;
		}
	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// FfblSz.vue?6c3c7f6a